export const config = {
    URL: "https://api.redeprocursos.com.br"
}